/**
 * app 依赖的回调执行的方法,避免报错,先声明一个空方法
 */
'use strict';

const Mama = window.Mama || {};

const setEmptyFn = (obj, str) => {
    str = str.split('.');
    for (const i of str) {
        if (!obj[i]) {
            obj[i] = () => {
                // 空函数声明
            };
        }
    }
};

Number(
    (function () {
        const fnObj = {
            window: {
                obj: window,
                data: [
                    'loginSuccess',
                    'loadLinks',
                    'logout',
                    'loginForMmqCode',
                    'setAudioIndex',
                    'setAudioStatus',
                    'setAudioProgress',
                    'shareCallBack'
                ]
            },
            Mama: {
                obj: Mama,
                data: ['getShare', 'loadLinks', 'shareResult', 'newWebCloseResult', 'getFuli', 'getFavor', 'noop']
            }
        };
        for (const i in fnObj) {
            if (Object.prototype.hasOwnProperty.call(fnObj, i)) {
                fnObj[i].data.map(function (val) {
                    setEmptyFn(fnObj[i].obj, val);
                });
            }
        }
    })()
);

/**
 * 阻止返回
 */
Mama.popPreviousStep = res => {
    const isAndroid = window.navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1;
    // 返回值给客户端
    const resp = {
        code: -1,
        data: {
            status: 0,
            opt: 2
        }
    };
    try {
        if (typeof res === 'string') {
            res = JSON.parse(res);
        }
        if (res.code == 0 && res.data) {
            const opt = res.data.opt;
            const status = Mama.popPreviousStep.opt[opt] ? 1 : 0;
            let obj = window;

            resp.code = 0;
            resp.data.status = status;
            resp.data.opt = opt;

            // IOS 阻止，返回 code 为 0
            if (status == 0 && !isAndroid) {
                resp.code = -1;
                return JSON.stringify(resp);
            }
            if (isAndroid) {
                obj = window['android'];
            }
            if (typeof obj[res.data.callback] === 'function') {
                // 执行回调通知客户端，停止默认操作（安卓）
                // ios 无 webGoBackCallBack，预计 7.6 版本修复，但不影响，因为它支持 return code == 0 行为也会阻止
                obj[res.data.callback](JSON.stringify(resp));
            }
            Mama.popPreviousStep.callback[opt] && Mama.popPreviousStep.callback[opt](opt);
        } else {
            console.error(res.msg);
        }
    } catch (error) {
        console.error(`popPreviousStep 发生了错误: ${error.message}`);
    }
    // 返回 code == 0 值 ios 就会阻止
    if (isAndroid) {
        resp.code = 0; // 安卓需要 code 为 0，取 status 的值判断
    }
    return JSON.stringify(resp);
};
Mama.popPreviousStep.opt = {1: false, 2: false}; // 1 返回 2 关闭
Mama.popPreviousStep.isBan = 0; // 废弃，不确定 app 旧版本是否在使用，过渡，暂不删除
Mama.popPreviousStep.callback = function () {
    // 空函数声明
};
window.Mama = Mama;
